module.exports = __webpack_public_path__ + "img/menu.a450cc10.svg";